export default "__VITE_ASSET__6e34e87a__"